<script setup>
import { gsap } from 'gsap'
import { onMounted, watch, ref, onUnmounted } from 'vue'
import linesBlue2 from '@/assets/images/parallax_imgs/linesBlue2.svg'
import linesSky from '@/assets/images/parallax_imgs/linesSky.svg'
import linesWBlue from '@/assets/images/parallax_imgs/linesWBlue.svg'
import linesWBlue2 from '@/assets/images/parallax_imgs/linesWBlue2.svg'
import linesBRed from '@/assets/images/parallax_imgs/linesBRed.svg'
import linesBRed2 from '@/assets/images/parallax_imgs/linesBRed2.svg'

import connect_to_spotify from '@/assets/images/servicios_empresariales/connect_to_spotify.png'
import importing_r from '@/assets/images/servicios_empresariales/importing_r.png'
import top_services from '@/assets/images/servicios_empresariales/top_services.png'
import cloud_data from '@/assets/images/servicios_empresariales/cloud_data.png'
import distribution_w from '@/assets/images/servicios_empresariales/distribution_w.svg'
import clip_dollar_w from '@/assets/images/clip_dollar_w.svg'
import data_w from '@/assets/images/servicios_empresariales/data_w.svg'
import gif05 from '@/assets/images/gifs/gif05.gif'
import AnimatedButton from '@/components/Home/AnimatedButton.vue'
import CardColor from '@/components/UserPremium/CardColor.vue'

/* PARRALAX */
let parallaxContainer = null
let layers = null

onMounted(() => {
  parallaxContainer = document.querySelector('.parallax-container')
  layers = document.querySelectorAll('.layer')

  gsap.set(layers, { x: 0, y: 0 }) // set initial position
  gsap.set(layers[2], { y: 1500 })
  gsap.set(layers[3], { y: 1500 })
  gsap.set(layers[4], { y: 2000 })
  gsap.set(layers[5], { y: 2000 })

  parallaxContainer.addEventListener('scroll', () => {
    const scrollPosition = parallaxContainer.scrollTop
    const speed = 0.8

    if (scrollPosition > 1100) {
      gsap.to(layers[0], {
        x: 0,
        y: 0,
        ease: 'none',
        duration: 0.7,
      })
    } else {
      gsap.to(layers[0], {
        x: -scrollPosition * speed,
        y: scrollPosition * (speed * 1.1),
        ease: 'none',
        duration: 0.7,
      })
    }

    if (scrollPosition > 1000) {
      gsap.to(layers[1], {
        x: 0,
        y: 0,
        ease: 'none',
        duration: 0.7,
      })
    } else {
      gsap.to(layers[1], {
        y: scrollPosition * (speed * 0.6),
        ease: 'none',
        duration: 0.6,
      })
    }

    if (scrollPosition > 2900) {
      gsap.to(layers[2], {
        x: 0,
        y: 0,
        ease: 'none',
        duration: 0.7,
      })
    } else {
      gsap.to(layers[2], {
        y: scrollPosition * (speed * 0.7),
        ease: 'none',
        duration: 0.8,
      })
    }

    if (scrollPosition > 2700) {
      gsap.to(layers[3], {
        x: 0,
        y: 0,
        ease: 'none',
        duration: 0.7,
      })
    } else {
      gsap.to(layers[3], {
        y: scrollPosition * (speed * 1.1),
        ease: 'none',
        duration: 0.8,
      })
    }

    gsap.to(layers[4], {
      y: scrollPosition * (speed * 0.6),
      ease: 'none',
      duration: 1,
    })
    gsap.to(layers[5], {
      y: scrollPosition * (speed * 0.7),
      ease: 'none',
      duration: 1,
    })
  })
})

//DSPLAZAMIENTO AUTOMATICO
onMounted(() => {
  const sections = document.querySelectorAll('section')
  sections.forEach((section) => {
    section.addEventListener('click', () => {
      const nextSection = section.nextElementSibling
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' })
      }
    })
  })
})
//FONDO GRADIENTE
// Método para animar el fondo con gradientes first section
const animateBackground = () => {
  // Seleccionar el elemento
  const element = document.querySelectorAll('.bgTransition')

  // Definir los gradientes
  const gradient1 = 'linear-gradient(127deg, #205771 18.11%, #000 88.57%)'
  const gradient2 = 'linear-gradient(72deg, #205771 0%, #000 81.79%)'
  const gradient3 = 'linear-gradient(293deg, #205771 3.42%, #000 89.99%)'

  // Crear la animación con GSAP
  gsap
    .timeline({ repeat: -1, yoyo: true })
    .to(element, { background: gradient2, duration: 3, ease: 'none' })
    .to(element, { background: gradient3, duration: 3, ease: 'none' })
    .to(element, { background: gradient1, duration: 3, ease: 'none' })
}

// Método para llamar a la animación cuando el componente se monta
document.addEventListener('DOMContentLoaded', () => {
  animateBackground()
})

// eslint-disable-next-line
const urlLogin = ref('https://panel.themusicdistribution.com/')
// eslint-disable-next-line
const urlSingUp = ref('https://panel.themusicdistribution.com/es/sign-up')
const currentUrl = window.location.pathname
if (currentUrl.indexOf('tmd-access') > -1) {
  urlLogin.value = 'https://distribucion.themusicdistribution.com/'
  urlSingUp.value =
    'https://distribucion.themusicdistribution.com/users/register'
}

const goToPlattform = (type) => {
  if (type === 2) {
    window.location.href = urlLogin.value
  } else {
    window.location.href = urlSingUp.value
  }
}
</script>
<template>
  <div>
    <div class="data-warehouses">
      <div class="parallax-container">
        <section id="section1" class="section bgTransition">
          <div class="layer-1">
            <img :src="linesBlue2" alt="Layer 1" class="layer-image1 layer" />
            <img :src="linesSky" alt="Layer 2" class="layer-image2 layer" />
          </div>
          <div class="order">
            <div class="central-content">
              <div class="first-container">
                <h1>
                  RECARGUE SUS <br />
                  DATOS
                </h1>
                <h4>
                  El almacén de datos como servicio de The Music Distribution le
                  permite gestionar miles de millones de microtransacciones con
                  eficacia y a gran escala.
                </h4>
                <div class="form-group">
                  <button type="button" @click="goToPlattform(1)" class="submit-button" style="text-wrap: nowrap">
                    OBTENLO AHORA
                  </button>
                </div>
              </div>
              <div class="second-container">
                <img
                  :src="gif05"
                  alt="logo-gif"
                  style="width: 100%; height: 100%; object-fit: fill"
                />
              </div>
            </div>
            <!-- *Se esconde en phone-->
            <div class="third-container">
              <div class="box">
                <div class="box-div-first">
                  <span class="text"> Totalmente gestionado</span>
                  <span class="sub-text">Almacenes de datos</span>
                </div>
                <div class="box-div-second">
                  <span class="text">Automatizado</span>
                  <span class="sub-text">Canalizaciones ETL</span>
                </div>
                <div class="box-div-third">
                  <span class="text">Escalable</span>
                  <span class="sub-text">Infraestructura</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- SECOND SECTION -->
        <section id="section2" class="section bgBlack">
          <div class="layer-2">
            <img :src="linesWBlue" alt="Layer 3" class="layer-image3 layer" />
            <img :src="linesWBlue2" alt="Layer 4" class="layer-image4 layer" />
          </div>
          <div class="order-third">
            <div class="container">
              <div>
                <div class="div-label-01">
                  <p>Automatizar</p>
                </div>
              </div>
              <h2>Automatice sus canalizaciones de datos y ETL</h2>
              <p>
                Acceda fácilmente a todos los datos del DSP sin necesidad de
                desarrolladores ni ingenieros. Experimente un rendimiento de
                nueva generación para la ingestión, el procesamiento y el
                análisis de sus datos.
              </p>

              <AnimatedButton></AnimatedButton>
            </div>
            <div class="d-flex w-100 justify-content-center">
              <div class="img-cont">
                <img
                  :src="connect_to_spotify"
                  alt="logos"
                  class="image-logos"
                />
              </div>
            </div>
          </div>
        </section>
        <!-- SECTION 3 -->
        <section id="section3" class="section bgBlack">
          <div class="order-fourth">
            <div class="container">
              <div>
                <div class="div-label-02">
                  <p>Ingerir</p>
                </div>
              </div>
              <h2>Ingesta de datos históricos de cualquier volumen</h2>
              <p>
                Cualquier número de fuentes de datos, de bajo a alto volumen.
                Integre todos sus datos históricos para obtener una visión
                completa de su actividad de streaming en las principales
                plataformas.
              </p>
              <AnimatedButton></AnimatedButton>
            </div>
            <!-- aqui -->
            <div class="d-flex w-100 justify-content-center">
              <div class="img-cont">
                <div class="container-img">
                  <img :src="importing_r" alt="songs" class="image-songs" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- SECTION 4 -->
        <section id="section4" class="section bgBlack">
          <div class="layer-3">
            <img :src="linesBRed" alt="Layer 5" class="layer-image5 layer" />
            <img :src="linesBRed2" alt="Layer 6" class="layer-image6 layer" />
          </div>
          <div class="order-fourth">
            <div class="container">
              <div>
                <div class="div-label-04">
                  <p>Perspectivas</p>
                </div>
              </div>
              <h2>Obtenga información más rápidamente</h2>
              <p>
                Limpiamos, normalizamos y transformamos automáticamente sus
                datos para que pueda dedicar menos tiempo a prepararlos para el
                análisis y acortar considerablemente el tiempo necesario para
                obtener información.
              </p>
              <AnimatedButton></AnimatedButton>
            </div>
            <!-- aqui -->
            <div class="d-flex w-100 justify-content-center">
              <div class="img-cont">
                <div class="container-img">
                  <img :src="top_services" alt="songs" class="image-songs2" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- SECTION 5 -->
        <section id="section5" class="section overlay-section">
          <div class="order-fourth">
            <div class="container">
              <div>
                <div class="div-label-03">
                  <p>Sincroniza</p>
                </div>
              </div>
              <h2>Proteja todos sus datos en la nube</h2>
              <p>
                Rellenamos automáticamente sus datos para que cualquier cambio
                en su flujo o actividad financiera se mantenga sincronizado en
                su almacén de datos.
              </p>
              <AnimatedButton></AnimatedButton>
            </div>
            <!-- aqui -->
            <div class="d-flex justify-content-center w-100">
              <div class="img-cont-02">
                <div class="container-img">
                  <img :src="cloud_data" alt="songs" class="image-songs" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section
        id="section6"
        class="bgTransition overlay-section2 z-2"
        style="height: auto !important; overflow-x: hidden"
      >
        <div style="height: 100%; width: 100%">
          <div class="layer-1" style="width: 100%; height: 100%">
            <img :src="linesBlue2" alt="Layer 1" class="img-last-01 layer" />
            <img :src="linesSky" alt="Layer 2" class="img-last-02 layer" />
          </div>
          <div class="order">
            <div class="central-content">
              <div class="first-container">
                <h1>
                  Obtener The music <br />
                  distribution
                </h1>
                <h4>para gestionar miles de millones de microtransacciones.</h4>
                <div class="form-group">
                  <button type="button" @click="goToPlattform(1)" class="submit-button">OBTENLO AHORA</button>
                </div>
              </div>
            </div>
            <!-- *Se esconde en phone-->
            <div class="third-container-last" style="min-height: 150px">
              <div class="d-flex align-items-center">
                <CardColor
                  :imgSrc="distribution_w"
                  title="Distribución y entrega"
                  text="Monetizar en todas partes"
                  background="linear-gradient(138deg, #7D1426 -37.97%, #D02140 108.31%)"
                ></CardColor>
              </div>
              <div class="d-flex align-items-center">
                <CardColor
                  :imgSrc="clip_dollar_w"
                  title="Informes de ingresos"
                  text="Simplificar la elaboración"
                  background="linear-gradient(92deg, #DA9721 -0.12%, #F2A825 100.29%)"
                ></CardColor>
              </div>
              <div class="d-flex align-items-center">
                <CardColor
                  :imgSrc="data_w"
                  title="Almacenes de datos"
                  text="Almacenes de datos totalmente gestionados"
                  background=" linear-gradient(92deg, #2198D0 -0.12%, #1E89BB 100.29%)"
                ></CardColor>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.overlay-section2 {
  position: relative;
}

.overlay-section {
  position: relative;
}

.overlay-section::before {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 293px; /* Ajusta la altura del resplandor */
  background: linear-gradient(180deg, rgba(17, 17, 17, 0) 0%, #205872 100%);
  pointer-events: none;
  opacity: 0.56;
  z-index: 3 !important; /* Asegura que el resplandor esté sobre el contenido */
}

.bgBlack {
  width: 100%;
  height: 100vh;
}
.bgTransition {
  width: 100%;
  height: 100vh;
  background: linear-gradient(127deg, #205771 18.11%, #000 88.57%);
}
.central-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 100px;
  position: relative;
  z-index: 1;
  height: 100vh;
  width: 100%;
}
@media (max-width: 768px) {
  .central-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0 20px;
    position: relative;
    z-index: 1;
  }
}

.parallax-container {
  position: relative;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

.layer {
  position: absolute;
  transform: translateZ(-1px);
}

.layer-image {
  width: 100%;
  height: 100vh;
  object-fit: cover;
  overflow: hidden;
}
.layer-image1 {
  width: 618px;
  height: 618px;
  opacity: 0.2;
  right: -139px;
  bottom: -54px;
}

.layer-image2 {
  opacity: 0.3;
  width: 340px;
  height: 485px;
  right: -190px;
  bottom: 140px;
}
.layer-image3 {
  width: 618px;
  height: 618px;
  left: -100px;
  bottom: -45%;
  opacity: 0.3;
}
.layer-image4 {
  width: 340px;
  height: 485px;
  right: -120px;
  bottom: -100px;
  opacity: 0.3;
}
.layer-image5 {
  opacity: 0.3;
  width: 618px;
  height: 618px;
  left: 0%;
  top: 200%;
  z-index: 2;
}
.layer-image6 {
  opacity: 0.3;
  width: 340px;
  height: 485px;
  right: 0%;
  top: 200%;
  z-index: 2;
}

@media (max-width: 768px) {
  .layer-image1 {
    width: 480px;
    height: 480px;
    opacity: 0.2;
    right: -139px;
    bottom: -54px;
  }

  .layer-image2 {
    opacity: 0.3;
    width: 250px;
    height: 395px;
    right: -150px;
    bottom: 140px;
  }
  .layer-image3 {
    width: 480px;
    height: 480px;
    left: -100px;
    bottom: -45%;
    opacity: 0.3;
  }
  .layer-image4 {
    width: 250px;
    height: 395px;
    right: -120px;
    bottom: -100px;
    opacity: 0.3;
  }
  .layer-image5 {
    opacity: 0.3;
    width: 480px;
    height: 480px;
    left: -30%;
    top: 200%;
  }
  .layer-image6 {
    opacity: 0.3;
    width: 250px;
    height: 395px;
    right: -10%;
    top: 210%;
  }
}
/* @media (min-width: 769px) and (max-width: 1024px) {
  .layer-image5 {
    right: -40%;
    top: -55%;
  }
} */
@media (min-width: 1600px) {
  .layer-image1 {
    opacity: 0.2;
    right: 0%;
    bottom: -10%;
  }
  .layer-image4 {
    right: -120px;
    bottom: -20%;
    opacity: 0.8;
  }
  .layer-image5 {
    opacity: 0.5;
    right: 50%;
    top: 200%;
    z-index: 1;
  }
  .layer-image6 {
    opacity: 0.5;
    width: 340px;
    height: 485px;
    right: 0%;
    top: 200%;
    z-index: 2;
  }
}
@media (max-width: 480px) {
  /* Estilos para dispositivos móviles pequeños */
  .layer-image1 {
    width: 300px;
    height: 300px;
    opacity: 0.2;
    right: -50px;
    bottom: -20px;
  }
  .layer-image2 {
    opacity: 0.3;
    width: 180px;
    height: 280px;
    right: -70px;
    bottom: 100px;
  }
  .layer-image3 {
    width: 300px;
    height: 300px;
    left: -50px;
    bottom: -20%;
    opacity: 0.5;
  }
  .layer-image4 {
    width: 180px;
    height: 280px;
    right: -60px;
    bottom: -50px;
    opacity: 0.8;
  }
  .layer-image5 {
    opacity: 0.5;
    width: 300px;
    height: 300px;
    right: -260%;
    bottom: -200px;
  }
}
.img-last-01 {
  width: 618px;
  height: 618px;
  opacity: 0.2;
  right: 5%;
  bottom: 20%;
  overflow: hidden;
}
.img-last-02 {
  opacity: 0.3;
  width: 340px;
  height: 485px;
  right: -190px;
  bottom: 30%;
  overflow: hidden;
}
@media (max-width: 768px) {
  .img-last-01 {
    width: 318px;
    height: 318px;
    opacity: 0.2;
    right: -139px;
    bottom: 20%;
    overflow: hidden !important;
  }

  .img-last-02 {
    opacity: 0.3;
    width: 240px;
    height: 385px;
    right: -150px;
    bottom: 30%;
    overflow: hidden !important;
  }
}
</style>
